<template>
  <CustomTable
    title=""
    :rowsData="this.rowsData"
    :columns="this.linksColumns"
    :loading="isFetching"
    :custom-body="true"
    :small="true"
    :show-search="false"
    :sticky-header="false"
  >
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center" verticalAlign="center">
          {{props.row.openspace_id}}
        </custom-table-cell>
        <custom-table-cell align="left" verticalAlign="center">
          <div style="display: block; max-width: 260px; overflow: auto;">
            <a :href="props.row.openspace_url" target="_blank" class="link">
              {{`${props.row.openspace_url?.slice(0, 50) || ''}...`}}
              <q-tooltip
                v-if="props.row.openspace_url"
                >{{ props.row.openspace_url }}</q-tooltip
              >
            </a>
            <CustomIcon
              icon="fas fa-copy"
              primary
              small
              class="linksIcon"
              title="Копировать ссылку"
              @click="copyText(props.row.openspace_url)"
            />
          </div>
        </custom-table-cell>
        <custom-table-cell align="center" verticalAlign="center">
          {{props.row.date_record}}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <CustomIcon
            icon="trash"
            approveMode
            :approve="() => this.deleteLink(props.row?.openspace_id)"
          />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomIcon from "@/components/common/CustomIcon";
import CustomPopup from "@/components/common/CustomPopup";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { getFloorOpenspace } from "../ResidentialSettings/services";
import { deleteFloorMapLink, linksColumns, copyText } from './services';

export default {
  name: "LinksTable",
  components: {CustomIcon, CustomTableCell, CustomTable,CustomPopup},
  props: ['floor_map_id', 'filters', 'onDataChange'],
  data() {
    return {
      linksColumns,
      rowsData: [],
      isFetching: false,
    }
  },
  methods: {
    copyText,
    async getData() {
      this.isFetching = true
      const res = await getFloorOpenspace(this.floor_map_id)
      this.isFetching = false
      if (!res) return
      this.rowsData = res
    },
    async deleteLink(id) {
      const res = await deleteFloorMapLink(this.floor_map_id, id, this.filters)
      if(!res) return
      this.onDataChange(res?.data)
      this.rowsData = res?.openspace || []
      this.showSucceedSnackbar()
    }
  },
  mounted() {
    this.getData()
  },
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar();
    return {showSucceedSnackbar};
  },
}
</script>

<style scoped lang="scss">
.link {
  color: #00368b; cursor: pointer; font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
}
</style>
